@if (asPopover) {
  <div class="filter-popover" (click)="$event.stopPropagation()">
    <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>

    <div class="filter-actions d-flex justify-content-end gap-2">
      <button mat-button type="button" (click)="clear()">Limpar</button>
      <button mat-flat-button color="primary" type="button" (click)="filter()">Aplicar</button>
    </div>
  </div>
} @else {
  <app-z-dialog
    [title]="title | translate"
    [contentTemplate]="contentTemplate"
    [actionButtonsTemplate]="buttonsTemplate"
  >
  </app-z-dialog>
}

<ng-template #contentTemplate>
  <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
</ng-template>

<ng-template #formTemplate>
  <form class="modern-filter" [formGroup]="formGroup">
    @for (field of fields; track field.key) {
      <section class="filter-section">
        <label class="filter-label">{{ field.label | translate }}</label>

        @switch (field.type) {
          @case ('text') {
            <z-input
              [formControlRef]="control(field.key)"
              [placeholder]="field.placeholder || ''"
              [mask]="field.mask || ''"
              [type]="field.inputType || 'text'"
            ></z-input>
          }

          @case ('chips') {
            @if (isOptionsChips(field)) {
              <mat-chip-listbox [formControlName]="field.key" [multiple]="field.multiple || false">
                @for (opt of field.options || []; track opt.value) {
                  <mat-chip-option [value]="opt.value">{{ opt.label | translate }}</mat-chip-option>
                }
              </mat-chip-listbox>
            } @else {
              <mat-form-field appearance="outline" class="w-100">
                <mat-chip-grid #chipGrid [attr.aria-label]="field.label">
                  @for (chip of chipsValue(field.key); track chip) {
                    <mat-chip-row (removed)="removeChip(field.key, chip)">
                      {{ chip }}
                      <button matChipRemove [attr.aria-label]="'remove ' + chip">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </mat-chip-row>
                  }
                </mat-chip-grid>
                <input
                  [placeholder]="field.placeholder || ''"
                  [matChipInputFor]="chipGrid"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="addChip(field.key, $event)"
                />
              </mat-form-field>
            }
          }

          @case ('select') {
            <mat-form-field appearance="outline" class="w-100">
              <mat-select [formControlName]="field.key" [placeholder]="field.placeholder || ''">
                @for (opt of field.options || []; track opt.value) {
                  <mat-option [value]="opt.value">{{ opt.label | translate }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @case ('date') {
            <mat-form-field appearance="outline" class="w-100">
              <input
                matInput
                [matDatepicker]="picker"
                [formControlName]="field.key"
                [placeholder]="field.placeholder || ''"
              />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          }
        }
      </section>
    }
  </form>
</ng-template>

<ng-template #buttonsTemplate>
  <z-button
    icon="file_copy"
    [label]="actionButton | translate"
    (clicked)="filter()"
    [disabled]="formGroup.invalid"
  ></z-button>
</ng-template>
